const Header = () => {
    return (
        <div className="mb-10 font-mono">
            <div className="inline-block mt-16 mb-5 mr-4 text-5xl font-bold">缩啦短链接</div>
            <div className="inline-block pl-4 text-xl font-normal border-l-4 border-black">简单易用的短链接生成工具，链接永久有效！</div>
        </div>
    );
}

export default Header;